import { ConfigMap } from '../avenues/ConnectedCollectionAvenue';

export const getBookmarkedCollections = () => ['2050646', '528054', '523358'];

export const AVENUE_CONFIGS = {
    bookmarks: {
        sorting: [{ id: 'title', desc: false }],
        facets: {
            title_lc: getBookmarkedCollections().map((value) => ({
                value,
                operator: 'contains',
            })),
        },
    },
    recents: {
        sorting: [{ id: 'lastUpdated', desc: true }],
    },
    all: {
        sorting: [{ id: 'title', desc: false }],
    },
} satisfies ConfigMap;
